import { css } from '@emotion/react'
import { partial } from 'lodash-es'
import { type HTMLAttributes } from 'react'
import { Gallery, Item } from 'react-photoswipe-gallery'
import { AttachmentType, FileAttachment as FileAttachmentType } from '../../states/attachment'
import FileAttachment from './FileAttachment'

export interface FileAttachmentGroupProps extends HTMLAttributes<HTMLDivElement> {
	data: FileAttachmentType[]
	onDelete?: (id: string) => void
}

/**
 * 展示附件
 */
export default function FileAttachmentGroup({
	data,
	onDelete,
	...props
}: FileAttachmentGroupProps) {
	return (
		<Gallery>
			<div
				css={css`
					display: flex;
					align-items: center;
					gap: 10px;
					overflow: auto hidden;

					&::-webkit-scrollbar {
						display: none;
					}
				`}
				{...props}
			>
				{data.map((item: FileAttachmentType, index: number) => {
					const content =
						item.type === AttachmentType.VIDEO ? (
							<video
								src={item.cdn?.file.fileUrl}
								width={item.metadata?.width}
								height={item.metadata?.height}
								controls
								muted
								playsInline
								autoPlay
								css={css`
									max-width: 90vw;
									max-height: 90vh;
									display: block;
									margin: 0 auto;
									height: fit-content;
								`}
							/>
						) : undefined

					return (
						<Item
							key={item.id}
							thumbnail={item.cdn?.file.fileUrl}
							original={item.cdn?.file.fileUrl}
							width={item.metadata?.width}
							height={item.metadata?.height}
							content={content}
						>
							{({ ref, open }) => (
								<FileAttachment
									ref={ref}
									onDelete={onDelete && partial(onDelete, item.id)}
									data={item}
									onClick={open}
								/>
							)}
						</Item>
					)
				})}
			</div>
		</Gallery>
	)
}
